<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { userInfoAction } from '@/api/cp-action.js';
import axios from 'axios';
export default {
  computed: {
    baseData() {
      return JSON.parse(sessionStorage.getItem('baseData'))
    },
  },
  created() {
    this.udc();
  },
  mounted() {
    // 主题色防刷新配置
    this.refreshConfig()
  },
  methods: {
    udc() {
      const userInfo = userInfoAction();
      Promise.all([userInfo.accountId(),userInfo.sessionId(),userInfo.deviceInfo()])
          .then(res=>{
              let account_id = res[0].data.account_id || -1;
              let session_id = res[1].data.session_id || -1;
              let device_id = res[2].data.device_no || -1;
              this.udcAjax({account_id,session_id,device_id});
          })
    },
    udcAjax(option) {
      const type = location.pathname.split('/')[1];
      const query = location.hash.split('?')[1];
      axios({
            url:`/activity/api.php?m=public&subm=actstatistics&${query}`,
            params: {
                ...this.$route.query,
                account_id: option.account_id,
                session_id: option.session_id,
                type
            },
            method: 'GET'
        })
        .then(res=>{
              if (res.data.code === 3001) {
                const activityInfo = {
                  ...option,
                  ...res.data.data
                }
                window.udc.updateActivity(activityInfo);
                window.udc.pageview();
              }
        })
        .catch(console.error)
    },
    refreshConfig() {
      // 标题设置
      if (!document.title && this.baseData) {
        document.title = this.baseData.page_title
      }
      // 主题色设置
      if (!getComputedStyle(document.querySelector('body')).getPropertyValue('--color') && this.baseData) {
        document.querySelector('body').style.setProperty('--color', this.baseData.theme_color)
      }
    }
  }
}
</script>

